import React from 'react';
import  Grid  from '@mui/material/Grid';
import Container from '@mui/material/Container';
import { Education } from './Education';
import { Employment } from './Employment';

export const Background: React.FC = () => {

    return (
        <Container sx={{ textAlign:'center', py:{xs:4, sm:8} }}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <Employment/>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Education/>
                </Grid>              
            </Grid>
        </Container>
    );
}